/* verqo — PreviewFooter (shared, marketing site · Feb 2026)
   every.io-style minimal footer per user pick (option A):
     • Brand block on the left (size='md' lockup + single-paragraph tagline
       matching the older marketing footer text — restored per user request)
     • 4 tight columns: Product / Solutions / Company / Legal
     • Only 3-4 top links per column — NOT a full sitemap
   Kills the duplicate-of-top-nav feel; users open the mega-menu for
   deeper discovery.
*/
import { Link } from "react-router-dom";
import { VerqoLockup } from "../VerqoLockup";

const COLUMNS = [
  {
    heading: "Product",
    links: [
      { label: "Catalog",        href: "/product/catalog" },
      { label: "Payments",       href: "/product/payments" },
      { label: "Credit terms",   href: "/product/credit-terms" },
      { label: "Pricing",        href: "/pricing" },
    ],
  },
  {
    heading: "Solutions",
    links: [
      { label: "Brands",        href: "/solutions/brands" },
      { label: "Distributors",  href: "/solutions/distributors" },
      { label: "3PLs",           href: "/solutions/3pls" },
      { label: "For buyers",     href: "/buyers" },
    ],
  },
  {
    heading: "Company",
    links: [
      { label: "Our story",    href: "/company/story" },
      { label: "How it works", href: "/company/how-it-works" },
      { label: "Partners",     href: "/company/partners" },
      { label: "Careers",      href: "/company/careers" },
      { label: "Contact",      href: "/company/contact" },
    ],
  },
  {
    heading: "Legal",
    links: [
      { label: "Terms & Privacy", href: "/legal/terms" },
      { label: "Security",         href: "/company/security" },
      { label: "Privacy",          href: "/company/privacy" },
      { label: "Status",           href: "/company/status" },
    ],
  },
];

export function PreviewFooter() {
  return (
    <footer className="mt-24 border-t border-slate-200" data-testid="preview-footer">
      <div className="max-w-[1280px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-[1.5fr_2fr] gap-12 lg:gap-16">
          {/* Brand block — restored to the older lockup + single-paragraph tagline */}
          <div>
            <div className="inline-flex items-center gap-2">
              <VerqoLockup size="md" />
              <span className="text-[12px] text-slate-500 whitespace-nowrap">· Wholesale, instant.</span>
            </div>
            <p className="mt-4 text-[13px] text-slate-500 leading-relaxed max-w-md" data-testid="footer-tagline">
              The operating system for wholesale.
            </p>
          </div>

          {/* 4 tight columns */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
            {COLUMNS.map((col) => (
              <div key={col.heading}>
                <div className="text-[11px] uppercase tracking-[0.22em] text-slate-500 font-semibold mb-4">
                  {col.heading}
                </div>
                <ul className="space-y-2.5">
                  {col.links.map((it) => (
                    <li key={it.href}>
                      <Link
                        to={it.href}
                        className="text-[13px] text-slate-700 hover:text-slate-900 transition-colors"
                        data-testid={`footer-link-${col.heading.toLowerCase()}-${it.label.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
                      >
                        {it.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Copyright bar — normal case, not uppercase */}
        <div className="mt-14 pt-6 border-t border-slate-100 flex flex-wrap items-center justify-between gap-3 text-[12px] text-slate-500">
          <div>© 2026 verqo · Wholesale, instant.</div>
          <div className="text-slate-400">All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}
